import mod from "-!./iconArrowRight.js?vue&type=script&lang=js&"; export default mod; export * from "-!./iconArrowRight.js?vue&type=script&lang=js&"